module.exports = __webpack_public_path__ + "static/media/lyft-logo.5b81c115.svg";